(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('orderItemsTable', function (ModalService, $rootScope) {
		return {
			scope: {
				products: '=',
                order: '='
			},
			templateUrl: 'directives/orderItemsTable/table.html',
			controller: function($scope, $uibModal) {

                var parent = $scope.$parent;

                $scope.restoreItem = function(idx){

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Restore this item to the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-success" type="button" ng-click="restore()">Restore</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.restore = function () {

                                scope.products[idx].deleted = false;

                                parent.save();

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });

                };

                $scope.removeItem = function(idx) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Remove this item from the order?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.delete = function () {

                                scope.products[idx].deleted = true;

                                parent.save();

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });

                };

                $scope.editItem = function(item) {
                    
                    var modalInstance = $uibModal.open({
                        size: 'lg',
                        animation: true,
                        templateUrl: 'directives/orderDetail/editOrderItem.html',
                        windowClass: 'edit_order_item_modal topmost',
                        backdropClass: 'topmost',
                        controller: function($scope, $uibModalInstance) {
                          $scope.itemTotal = 0;
                          $scope.itemCount = 0;
                          $scope.selections = {};
                          $scope.item = item;

                          $scope.propertyEditorRowSave = function () {

                              parent.save();

                          };

                          $scope.close = function () {
                              $uibModalInstance.dismiss('cancel');
                          };

                        //   $scope.setTotals = function() {
                        //       $scope.itemCount = _.reduce($scope.item.properties, function(memo, property){
                        //           return property.purchased ? memo + 1 : memo;
                        //       }, 0);
                          //
                        //       $scope.itemTotal = ($scope.item.basePrice || 0) +  _.reduce($scope.item.properties, function(memo, property){
                        //           return memo + (property.purchased.price || 0);
                        //       }, 0);
                          //
                        //       $scope.itemTotal = $scope.itemTotal * parseInt($scope.item.quantity);
                        //   };
                          //
                        //   $scope.$on('selectionChanged', function() {
                        //       $scope.setTotals();
                        //   });
                          //
                        //   $scope.$on('item.quantity', function() {
                        //       $scope.setTotals();
                        //   });
                          //
                        //   $scope.submitForm = function(form, data) {
                        //       $element.modal('hide');
                        //       //  Now close as normal, but give 500ms for bootstrap to animate
                        //       close(null, 500);
                        //   };
                          //
                        //    $scope.setTotals();
                      }
                    });
                };

			}
		};
	});

})();
